module.exports = __webpack_public_path__ + "img/plus.0a0eab2f.svg";